
import { defineComponent, onMounted, onUnmounted, reactive, ref } from 'vue'
import { Search, Delete, Edit } from '@element-plus/icons-vue'
import moment from "moment";
import {
  ElInput,
  ElButton,
  ElIcon,
  ElTable,
  ElPagination,
  ElTableColumn,
  ElDialog,
  ElForm,
  ElFormItem,
  ElSelect,
  ElOption,
  ElDatePicker,
  ElMessageBox,
  ElMessage,
  ElSwitch,
  ElRadioGroup,
  ElRadio,
  ElUpload,
} from 'element-plus'
import service from '@/services'
import { ElFormType } from '@/Types/ElementTypes'
import { SystemMessage } from '@/Tool/LoginSet'
import vuex from '@/store'
import { $t as lang } from '@/Tool'

interface IRow {
  title: string
  type: 0 | 1
  content: string
  publishTime?: Date
  expireTime?: Date
  publishChannel?: 0 | 1 | 2 // 发布渠道 0：全部 1：WEB 2：APP
  id?: number
  showDetail: boolean
  attachmentDesc?: string // 附件描述
  attachmentType: 0 | 1 // 附件来源 0：本地 1：web链接
  attachmentUrl?: string // 附件地址
}

export default defineComponent({
  components: {
    Search,
    Delete,
    Edit,
    ElInput,
    ElButton,
    ElIcon,
    ElTable,
    ElPagination,
    ElTableColumn,
    ElDialog,
    ElForm,
    ElFormItem,
    ElSelect,
    ElOption,
    ElDatePicker,
    ElMessageBox,
    ElMessage,
    ElSwitch,
    ElRadioGroup,
    ElRadio,
    ElUpload,
  },
  setup() {
    const tableData = ref([])
    const total = ref(0)
    const currentPage = ref(1)
    const keyword = ref()
    const dialogVisible = ref(false)
    const formRef = ref<ElFormType>()
    const form: IRow = reactive({
      title: '',
      type: 1,
      content: '',
      publishTime: undefined,
      expireTime: undefined,
      publishChannel: 0,
      id: undefined,
      showDetail: false,
      attachmentDesc: undefined,
      attachmentType: 0,
      attachmentUrl: undefined,
    })
    const tableHeight = ref(window.innerHeight - 290)
    const FuncSystemMessage = new SystemMessage({})
    const fileList = ref([] as any)
    const upload = ref()
    const uploadParam = ref({
      uploadReq: new Blob([JSON.stringify({})], { type: 'application/json' }),
    })

    const getMessageList = () => {
      service.MessageApi.queryManageList({
        data: {
          asc: false,
          keyword: keyword.value,
          page: currentPage.value,
          size: 10,
        },
      }).then((resp) => {
        const { data, success } = resp
        if (success) {
          tableData.value = data['records'] || []
          total.value = data['totalRecord'] || 0
        }
      })
    }

    const handleCurrentChange = (val: number) => {
      currentPage.value = val
      getMessageList()
    }
    const handleSearch = () => {
      currentPage.value = 1
      getMessageList()
    }

    const handleFormat = (row: IRow) => {
      console.log(row)
      const { publishChannel } = row
      // 发布渠道 0：全部 1：WEB 2：APP
      if (publishChannel === 0) {
        return lang('messageCenter.tableLIst.publishChannel.[0]')
      } else if (publishChannel === 1) {
        return 'WEB'
      } else {
        return 'APP'
      }
    }

    const submit = async () => {
      await formRef.value?.validate((valid: boolean) => {
        if (valid) {
          const { showDetail, ...restForm } = form
          const params = {
            ...restForm,
            expireTime:restForm.expireTime?moment(restForm.expireTime).format('YYYY-MM-DD HH:mm:ss'):''
          }
          const exp = new Date(params.expireTime).getTime()
          const pub = new Date(params.publishTime as any).getTime()
          if(restForm.expireTime && pub > exp){
              ElMessage({
                  type: 'warning',
                  message: lang('msg.endTime.greaterThan.startTime'),
              })
          }else{
              service.MessageApi.saveOrUpdateMessage({
                  data: {
                      ...params,
                  },
              }).then((resp) => {
                  if (resp.success) {
                      ElMessage({
                          type: 'success',
                          message: form.id ? lang('messageCenter.tableLIst.modifySuc') : lang('messageCenter.tableLIst.addSuc'),
                      })
                      dialogVisible.value = false
                      currentPage.value = 1
                      FuncSystemMessage.getMessageInfo(vuex.state.user.info.userId)
                      getMessageList()
                  }
              })
          }

        }
      })
    }

    const handleDialogClose = () => {
      form.publishTime = undefined
      form.expireTime = undefined
      form.publishChannel = 0
      form.id = undefined
      form.type = 1
      form.title = ''
      form.content = ''
      form.showDetail = false
      form.attachmentDesc = undefined
      form.attachmentType = 0
      form.attachmentUrl = undefined
      fileList.value = []
    }

    const handleDelete = (row: IRow) => {
      ElMessageBox.confirm(lang('messageCenter.tableLIst.tipMsg') + '？', lang('messageCenter.tableLIst.confirmTips'), {
        confirmButtonText: lang('messageCenter.tableLIst.btnConfirm'),
        cancelButtonText: lang('messageCenter.tableLIst.btnCancel'),
        type: 'warning',
      }).then(() => {
        service.MessageApi.deleteMessage({
          data: {
            id: row.id,
          },
        }).then((resp) => {
          if (resp.success) {
            ElMessage({
              type: 'success',
              message: lang('messageCenter.tableLIst.delSuc'),
            })
            currentPage.value = 1
            getMessageList()
          }
        })
      })
    }

    const handleEdit = (row: IRow) => {
      form.publishTime = new Date(row.publishTime!)
      form.expireTime = new Date(row.expireTime!)
      form.publishChannel = row.publishChannel
      form.id = row.id
      form.type = row.type
      form.title = row.title
      form.content = row.content
      if (row.attachmentUrl) {
        form.showDetail = true
        form.attachmentUrl = row.attachmentUrl
        form.attachmentType = row.attachmentType
        form.attachmentDesc = row.attachmentDesc
        if (row.attachmentType === 0) {
          const fileNameList = row.attachmentUrl.split('/')
          fileList.value = [
            {
              name: fileNameList[fileNameList.length - 1],
              url: row.attachmentUrl,
            },
          ]
        }
      }
      dialogVisible.value = true
    }

    const calcTableHeight = () => {
      tableHeight.value = window.innerHeight - 290
    }

    const handleExceed = (files: any) => {
      upload.value!.clearFiles()
      const file = files[0]
      upload.value!.handleStart(file)
      upload.value!.submit()
    }

    const handleUploadSuccess = (response: any) => {
      const { success, data } = response
      if (success) {
        form.attachmentUrl = data.path
        fileList.value = [{ name: data.name, url: data.path }]
      }
    }

    const handleRemove = () => {
      form.attachmentUrl = undefined
    }

    const validateAttachmentUrl = (rule: any, value: any, callback: any) => {
      if (!form.attachmentUrl) {
        if (form.attachmentType === 0) {
          return callback(new Error(lang('messageCenter.tableLIst.source.checkText')))
        } else {
          return callback(new Error(lang('messageCenter.tableLIst.btntextPlaceholder')))
        }
      } else {
        return callback()
      }
    }

    const rules = {
      title: [{ required: true, trigger: 'blur', message: lang('messageCenter.tableLIst.title.checkText') }],
      type: [{ required: true, trigger: 'change', message: lang('messageCenter.tableLIst.type.checkText') }],
      content: [{ required: true, trigger: 'blur', message: lang('messageCenter.tableLIst.content.checkText') }],
      publishTime: [{ type: 'date', required: true, trigger: 'change', message: lang('messageCenter.tableLIst.publishTime.checkText') }],
      publishChannel: [{ required: true, trigger: 'change', message: lang('messageCenter.tableLIst.publishChannel.checkText') }],
      attachmentDesc: [{ required: true, trigger: 'blur', message: lang('messageCenter.tableLIst.btntext.checkText') }],
      attachmentUrl: [
        { required: true, trigger: 'blur, change', validator: validateAttachmentUrl },
      ],
    }

    const handleAttachmentTypeChange = () => {
      fileList.value = []
      form.attachmentUrl = undefined
      formRef.value!.validate()
    }

    onMounted(() => {
      getMessageList()
      window.addEventListener('resize', () => calcTableHeight())
    })

    onUnmounted(() => {
      window.removeEventListener('resize', () => calcTableHeight())
    })

    return {
      tableData,
      total,
      currentPage,
      keyword,
      dialogVisible,
      form,
      rules,
      formRef,
      tableHeight,
      upload,
      uploadParam,
      fileList,
      handleCurrentChange,
      handleSearch,
      submit,
      handleDialogClose,
      handleDelete,
      handleEdit,
      calcTableHeight,
      handleExceed,
      handleUploadSuccess,
      handleRemove,
      validateAttachmentUrl,
      handleAttachmentTypeChange,
      handleFormat,
      lang
    }
  },
})
